import { getNewsPrefix } from '@/news-translations';

/**
 * True when an href points into the editorial `/news` CMS, which is served
 * outside this Next app (only proxied in on the production domain). Such links
 * must render as a plain `<a>`, never `next/link` — App Router would RSC-prefetch
 * and client-navigate the route, which 404s (e.g. surfaces as console errors in
 * the home smoke test, and wasteful prefetch traffic in production).
 */
export const isNewsHref = (href?: string): boolean => Boolean(href?.startsWith(`/${getNewsPrefix()}`));
